<template>
  <div class="w-full">
    <div class="h-px w-full bg-grey-light" />
  </div>
</template>

<script setup lang="ts"></script>
